import { useState } from 'react';

import { EventBusyOutlined, EventRepeatOutlined } from '@mui/icons-material';
import { Button, Menu, styled } from '@mui/material';
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';
import { wellzTheme } from '@wellz-theme/mui';
import { FormattedMessage, useIntl } from 'react-intl';
import { wellzTheme as theme } from 'theme/wellzTheme';

import { RescheduleDropdownButtonProps } from './types';

import * as S from './styles';

export const CustomWidthTooltip = styled(
  ({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ),
)({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: 197,
    height: 56,
    textAlign: 'center',
    fontSize: wellzTheme.typography.body2.fontSize,
    fontWeight: wellzTheme.typography.body2.fontWeight,
    fontFamily: wellzTheme.typography.fontFamily,
    padding: wellzTheme.spacing(1),
  },
});

export const RescheduleDropdownButton: React.FC<RescheduleDropdownButtonProps> =
  ({ handleCancelSession, handleRescheduleSession, rescheduledSession }) => {
    const intl = useIntl();
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [isOpened, setIsOpened] = useState(false);

    return (
      <>
        <Button
          variant="outlined"
          ref={setAnchorEl}
          onClick={() => setIsOpened(true)}
          size="small"
        >
          <FormattedMessage id="CAREMATRIXCPTC.BOOKINGSESSIONBUTTON.CANCEL" />
          <S.ChevronByParameter
            mode={isOpened ? 'opened' : 'closed'}
            width={wellzTheme.spacing(2.5)}
            height={wellzTheme.spacing(2.5)}
          />
        </Button>

        <Menu
          anchorEl={anchorEl}
          open={isOpened}
          onClose={() => setIsOpened(false)}
          onClick={() => setIsOpened(false)}
          transformOrigin={{ horizontal: 'right', vertical: 'top' }}
          anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
          sx={{ '& .MuiMenu-paper': { backgroundColor: 'white' } }}
        >
          <S.MenuItem
            data-testid="cancel-session-button"
            onClick={() => {
              handleCancelSession();
              return setIsOpened(false);
            }}
          >
            <EventBusyOutlined
              width={wellzTheme.spacing(3)}
              height={wellzTheme.spacing(3)}
              style={{ fill: theme.colors.inputDisabled }}
            />
            <div style={{ width: wellzTheme.spacing(1.5) }} />
            <FormattedMessage id="CPPLATAFORM.CPTCCAREMATRIX.DROPDOWNMENUCANCEL" />
          </S.MenuItem>

          <CustomWidthTooltip
            title={intl.formatMessage({
              id: 'CPPLATAFORM.CPNEWTIMECONFIRM.BOXINFORMATION',
            })}
            placement="top"
            arrow
            disableHoverListener={!rescheduledSession}
          >
            <div data-testid="reschedule-session-button">
              <S.MenuItem
                onClick={() => {
                  handleRescheduleSession();
                  return setIsOpened(false);
                }}
                disabled={rescheduledSession}
              >
                <EventRepeatOutlined
                  width={wellzTheme.spacing(3)}
                  height={wellzTheme.spacing(3)}
                  style={{ fill: theme.colors.inputDisabled }}
                />
                <div style={{ width: wellzTheme.spacing(1.5) }} />
                <FormattedMessage id="CPPLATAFORM.CPTCCAREMATRIX.DROPDOWNMENUCANCELANDCREATE" />
              </S.MenuItem>
            </div>
          </CustomWidthTooltip>
        </Menu>
      </>
    );
  };
